import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Filter({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Filter.Outline {...props} /> : <Filter.Solid {...props} />;
}

Filter.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 6.84625C3.25 5.13132 4.64903 3.75 6.36314 3.75C8.07726 3.75 9.47629 5.13132 9.47629 6.84625C9.47629 8.56119 8.07726 9.94251 6.36314 9.94251C4.64903 9.94251 3.25 8.56119 3.25 6.84625ZM6.36314 5.25C5.46729 5.25 4.75 5.96987 4.75 6.84625C4.75 7.72263 5.46729 8.44251 6.36314 8.44251C7.259 8.44251 7.97629 7.72263 7.97629 6.84625C7.97629 5.96987 7.259 5.25 6.36314 5.25Z"
          fill="currentColor"
        />
        <path
          d="M13.1405 6.15039C12.7263 6.15039 12.3905 6.48618 12.3905 6.90039C12.3905 7.3146 12.7263 7.65039 13.1405 7.65039H19.4412C19.8554 7.65039 20.1912 7.3146 20.1912 6.90039C20.1912 6.48618 19.8554 6.15039 19.4412 6.15039H13.1405Z"
          fill="currentColor"
        />
        <path
          d="M4.02942 15.8429C3.61521 15.8429 3.27942 16.1787 3.27942 16.5929C3.27942 17.0071 3.61521 17.3429 4.02942 17.3429H10.3301C10.7443 17.3429 11.0801 17.0071 11.0801 16.5929C11.0801 16.1787 10.7443 15.8429 10.3301 15.8429H4.02942Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6376 13.4575C15.9229 13.4575 14.5237 14.8387 14.5237 16.5538C14.5237 18.2689 15.9229 19.65 17.6376 19.65C19.3521 19.65 20.75 18.2684 20.75 16.5538C20.75 14.8392 19.3521 13.4575 17.6376 13.4575ZM16.0237 16.5538C16.0237 15.6776 16.7408 14.9575 17.6376 14.9575C18.5332 14.9575 19.25 15.6771 19.25 16.5538C19.25 17.4305 18.5332 18.15 17.6376 18.15C16.7408 18.15 16.0237 17.43 16.0237 16.5538Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Filter.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 6.84625C3.25 5.13132 4.64903 3.75 6.36314 3.75C8.07726 3.75 9.47629 5.13132 9.47629 6.84625C9.47629 8.56119 8.07726 9.94251 6.36314 9.94251C4.64903 9.94251 3.25 8.56119 3.25 6.84625ZM6.36314 5.25C5.46729 5.25 4.75 5.96987 4.75 6.84625C4.75 7.72263 5.46729 8.44251 6.36314 8.44251C7.259 8.44251 7.97629 7.72263 7.97629 6.84625C7.97629 5.96987 7.259 5.25 6.36314 5.25Z"
          fill="currentColor"
        />
        <path
          d="M13.1405 6.15039C12.7263 6.15039 12.3905 6.48618 12.3905 6.90039C12.3905 7.3146 12.7263 7.65039 13.1405 7.65039H19.4412C19.8554 7.65039 20.1912 7.3146 20.1912 6.90039C20.1912 6.48618 19.8554 6.15039 19.4412 6.15039H13.1405Z"
          fill="currentColor"
        />
        <path
          d="M4.02942 15.8429C3.61521 15.8429 3.27942 16.1787 3.27942 16.5929C3.27942 17.0071 3.61521 17.3429 4.02942 17.3429H10.3301C10.7443 17.3429 11.0801 17.0071 11.0801 16.5929C11.0801 16.1787 10.7443 15.8429 10.3301 15.8429H4.02942Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6376 13.4575C15.9229 13.4575 14.5237 14.8387 14.5237 16.5538C14.5237 18.2689 15.9229 19.65 17.6376 19.65C19.3521 19.65 20.75 18.2684 20.75 16.5538C20.75 14.8392 19.3521 13.4575 17.6376 13.4575ZM16.0237 16.5538C16.0237 15.6776 16.7408 14.9575 17.6376 14.9575C18.5332 14.9575 19.25 15.6771 19.25 16.5538C19.25 17.4305 18.5332 18.15 17.6376 18.15C16.7408 18.15 16.0237 17.43 16.0237 16.5538Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
